import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PresentationState } from './presentation.reducer';

export const selectPresentationState = createFeatureSelector<PresentationState>('presentation');

export const currentTemplate = createSelector(
    selectPresentationState,
    presentation => presentation.currentTemplate
);
